import PayOnUsWidgetButton from './PayOnUsWidgetButton';

export default PayOnUsWidgetButton;
